
import { Uuid } from "../../../../domain/model/uuid/uuid.type";
import { DataStoreId } from "../../data-store-id.type";

export class StoreSection implements DataStoreId {
  readonly id: string;
  readonly name: string;

  constructor(id: Uuid, name: string) {
    this.id = id.asString();
    this.name = name;
  }
}
